module.exports = __webpack_public_path__ + "img/jacket.83803b6a.svg";